import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppConfigService } from 'src/app/appConfig.service';

@Injectable({
    providedIn: 'root'
})
export class HttpInternalService {

    // Ensure charset is included so servers that inspect charset see application/json with UTF-8
    public headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

    constructor(private _http: HttpClient, private configService: AppConfigService) { }
    
    private get baseUrl(): string {
        return this.configService.apiURL;
    }

    public getRequest<T>(url: string, httpParams?: any, responseType?: any, headers?: any): Observable<T> {
        return this._http.get<T>(
            this.buildUrl(url),
            {
                headers: !headers ? this.getHeaders() : headers,
                params: httpParams,
                responseType: !responseType ? 'json' : responseType,
                withCredentials: true // ✅ ADD THIS
            }
        );
    }

    public postClearRequest<T>(url: string, payload: object): Observable<T> {
        return this._http.post<T>(
            this.buildUrl(url),
            payload,
            { withCredentials: true } // ✅ ADD THIS
        );
    }

    public postRequest<T>(url: string, payload: any, headers?: any, responseType?: any): Observable<T> {
        return this._http.post<T>(
            this.buildUrl(url),
            payload,
            {
                headers: !headers ? this.getHeaders() : headers,
                responseType: !responseType ? 'json' : responseType,
                withCredentials: true // ✅ ADD THIS
            }
        );
    }

    async postPromiseRequest(url: string, payload: object): Promise<any> {
        return await this._http.post(
            this.buildUrl(url),
            payload,
            { withCredentials: true } // ✅ ADD THIS
        ).toPromise() as any;
    }


    public putRequest<T>(url: string, payload: object, headers?: any): Observable<T> {
        return this._http.put<T>(
            this.buildUrl(url),
            payload,
            {
                headers: !headers ? this.getHeaders() : headers,
                withCredentials: true // ✅ ADD THIS
            }
        );
    }

    public patchRequest<T>(url: string, payload: object, headers?: any): Observable<T> {
        return this._http.patch<T>(
            this.buildUrl(url),
            payload,
            {
                headers: !headers ? this.getHeaders() : headers,
                withCredentials: true
            }
        );
    }

    public deleteRequest<T>(url: string, httpParams?: any, headers?: any): Observable<T> {
        return this._http.delete<T>(
            this.buildUrl(url),
            {
                headers: !headers ? this.getHeaders() : headers,
                params: httpParams,
                withCredentials: true // ✅ ADD THIS
            }
        );
    }

    /**
     * SD-1240. An address on the API for something the browser fetches itself (an <img src>), which
     * skips buildUrl. "/api/master-contacts/x/logo" or "master-contacts/x/logo" becomes the API's
     * own address: http://localhost:51016/api/master-contacts/x/logo when the app runs under
     * ng serve, unchanged "/api/..." when app and API share a host.
     */
    public apiUrl(path: string): string {
        if (!path) return path;
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const rest = path.replace(/^\/?api\//i, '').replace(/^\/+/, '');
        return this.baseUrl + rest;
    }

    public buildUrl(url: string): string {
        if (url.startsWith('http://') || url.startsWith('https://') || url.includes("/api/")) {
            return url;
        }
        return this.baseUrl + url;
    }

    public getHeaders(): HttpHeaders {
        return this.headers;
    }

    public deleteHeader(key: string) {
        this.headers = this.headers.delete(key);
    }

    public prepareData = (payload: object): string => JSON.stringify(payload);
}
